<script setup> 
import { ref, onMounted } from "vue";
import { Carousel, Slide, Navigation, Pagination } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

const posts = ref([]);

onMounted(async () => {
  try {
    const response = await fetch('/api/instagram')
    const data = await response.json()
    if (response.ok && !data.error && Array.isArray(data.data)) {
      posts.value = data.data
    }
  } catch (_) {
    // The Instagram strip is optional on the home page; fail silently when
    // Meta is unavailable instead of producing an unhandled client error.
    posts.value = []
  }
})
</script>

<template>
  <div v-if="posts.length" class="max-w-5xl mx-auto py-4">
    <h2 class="text-2xl font-bold text-center mb-0 font-2">{{$t('Instagram Paylaşımlarımız')}}</h2>
    
    <Carousel v-if="posts.length" :items-to-show="3" :wrap-around="false" class="py-2">
      <Slide v-for="post in posts" :key="post.id" >
        <div class="relative group mx-4">
          <!-- Resim veya Video -->
         
            <img 
              v-if="post.media_type === 'IMAGE'" 
              :src="post.media_url" 
              :alt="post.caption"
              class="w-full h-80 object-cover rounded-xl shadow-lg group-hover:opacity-80 transition"
            />
            <img 
              v-if="post.media_type === 'CAROUSEL_ALBUM'" 
              :src="post.media_url" 
              :alt="post.caption"
              class="w-full h-80 object-cover rounded-xl shadow-lg group-hover:opacity-80 transition"
            />
            <video 
              v-else-if="post.media_type === 'VIDEO'" 
              :src="post.media_url" 
              controls 
              class="w-full h-80 rounded-xl shadow-lg"
            ></video>

          <a :href="post.permalink" target="_blank" class="absolute top-5 right-5 shadow-lg ">
            <font-awesome-icon icon="fa-solid fa-external-link" class="h-8 w-8 shadow-lg text-slate-100"></font-awesome-icon>
          </a>

          <!-- Caption (hover ile görünür olacak) -->
          <div 
            class="absolute bottom-0 left-0 right-0 max-h-48 bg-black/50 text-white p-3 text-xs opacity-0 group-hover:opacity-100 transition duration-300"
          >
            {{ post.caption }}
          </div>
        </div>
      </Slide>

      <template #addons>
        <Navigation /> 
      </template>
    </Carousel>
  </div>
</template>
